module.exports = "<app-loading></app-loading>\n<app-header></app-header>\n<router-outlet></router-outlet>\n"